import clsx from "clsx";

import { PropsOf } from "../../types";
import { Currency } from "../components";
import { Language } from "../../types";

interface CurrencyWithDiscountProps
  extends Omit<PropsOf<typeof Currency>, "children"> {
  total: number | string;
  discount: number | string;
  id?: string;
  language: Language;
  emphasized?: boolean;
  trimDecimal?: boolean;
  horizontal?: boolean;
}

const CurrencyWithDiscount = ({
  prefix,
  total,
  discount,
  className,
  id,
  language,
  emphasized,
  trimDecimal,
  horizontal,
}: CurrencyWithDiscountProps) => {
  const hasDiscount = +discount > 0;
  const horizontalDisplayStyles =
    "grow [&>div]:align-middle [&>div>span:last-of-type]:text-base [&>div]:flex-row-reverse [&>div]:gap-1 [&>div]:items-center justify-end";

  return (
    <div
      className={clsx(
        "flex gap-2",
        horizontal && horizontalDisplayStyles,
        className,
      )}
      id={id}
    >
      {hasDiscount && (
        <div className="flex flex-col flex-wrap">
          <Currency
            language={language}
            className="text-base text-discount"
            prefix={prefix}
            emphasized={emphasized}
            trimDecimal={trimDecimal}
          >
            {+total}
          </Currency>

          <Currency
            language={language}
            className="text-sm line-through text-grey-1"
            prefix={prefix}
            trimDecimal={trimDecimal}
          >
            {+total + +discount}
          </Currency>
        </div>
      )}

      {!hasDiscount && (
        <Currency
          language={language}
          prefix={prefix}
          emphasized={emphasized}
          trimDecimal={trimDecimal}
        >
          {+total}
        </Currency>
      )}
    </div>
  );
};

export default CurrencyWithDiscount;
